<template>
  <Teleport to="body">
    <div class="tw-overlay tw-w-screen tw-h-screen tw-flex tw-justify-center tw-items-center tw-p-6">
      <slot>
        <shared-loading :size="64" color="white" />
      </slot>
    </div>
  </Teleport>
</template>
